module.exports = __webpack_public_path__ + "static/media/request-loan.d99daea1.svg";